import { useMutation } from 'react-query'

import { queryClient } from '../../../../../config/queryClient'
import { QueryKeys } from '../../../../../enums/queryKeys'
import { APIError } from '../../../../../utils'
import { TaxationType } from '../enums/taxationType'
import { FetchTaxationTypeResponseData, updateTaxationType } from '../query-api'

interface UseUpdateTaxationTypeProps {
  onError?: (error?: APIError) => void
  onSuccess?: (data: FetchTaxationTypeResponseData) => void
}

interface UpdateTaxationTypeArgs {
  organizationId: string
  taxationType: TaxationType
}

export const useUpdateTaxationType = (props?: UseUpdateTaxationTypeProps) => {
  const { onError, onSuccess } = props || {}

  const { mutateAsync: updateAsync, isLoading: isProcessing } = useMutation(
    ({ organizationId, taxationType }: UpdateTaxationTypeArgs) => updateTaxationType(organizationId, taxationType),
    {
      onSuccess: async (data, { organizationId }) => {
        await queryClient.invalidateQueries([QueryKeys.TaxationTypeSettings, organizationId])
        onSuccess?.(data)
      },
      onError: (error: APIError) => {
        onError?.(error)
      },
    },
  )

  return { updateAsync, isProcessing }
}
